import { IconArrowBackUp } from "@tabler/icons-react";
import type { TableCardAction } from "@onengine/component-library";

export const RESET_COLUMNS_LABEL = "Reset Columns";

/**
 * The way back from a column resize.
 *
 * Widths, order and visibility are remembered per browser, and the library offers no reset of
 * its own (its Edit Columns menu does show/hide and order only), so without this a careless
 * drag is permanent. It is offered only once something has actually been changed, so a toolbar
 * nobody has touched does not carry an action that would do nothing.
 */
export const resetColumnsAction = (onClick: () => void): TableCardAction => ({
  label: RESET_COLUMNS_LABEL,
  icon: <IconArrowBackUp size={16} />,
  onClick,
});
